import React from 'react';
import PropTypes from 'prop-types';

import { ButtonBase } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Container } from './styles';

const StyledButtonBase = withStyles({
  root: {
    borderRadius: 3.76284,
    color: '#FFFFFF',
    backgroundColor: '#0384AC',
    fontSize: 16,
    minWidth: 180,
    minHeight: 40,
    marginTop: 32,
  },
})(ButtonBase);

const SimpleButton = ({ children, ...params }) => {
  return (
    <Container>
      <StyledButtonBase {...params}>{children}</StyledButtonBase>
    </Container>
  );
};

SimpleButton.propTypes = {
  children: PropTypes.string.isRequired,
};

export default SimpleButton;
